export const SET_USER = 'current-user/set-user';
export const UNSET_USER = 'current-user/unset-user';
export const SET_HEADER_STATUS = 'current-user/header-status';
export const SET_SETTINGS_DATA = 'current-user/set-settings-data';
